var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 40,
    viewBox: "0 0 114 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.8373 11.762H93.9193L90.2249 15.4297V28.487H93.9193V23.4037H97.8373V28.487H101.532V15.4297L97.8373 11.762ZM96.4471 19.7376H93.9193V15.4297H97.8373V19.7376H96.4471Z",
    fill: "#27A536"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4376 22.3081V24.8193H65.0492H62.5214V11.762H58.8269V24.8193L62.5214 28.487H65.0492H66.4376L70.1321 24.8193V22.3081V11.762H66.4376V22.3081Z",
    fill: "#27A536"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2204 11.762L74.5259 15.4297V15.4805V18.3507L78.2204 22.0185H82.1383V24.528V24.8193H79.6088H74.5259V28.487H79.6088H82.1383L85.8311 24.8193V24.528V22.0574V22.0185L82.1383 18.3507H78.2204V15.4805V15.4297H80.7482H85.8311V11.762H80.7482H78.2204Z",
    fill: "#27A536"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3389 11.762H11.7264V28.487H15.4209V22.0185H19.3389V28.487H23.0333V22.0185L21.1827 20.2202L21.1673 20.2049L23.035 18.3507V15.4213H23.0282L19.3406 11.762H19.3389ZM15.4209 18.3507V15.428H19.3389V18.3507H15.4209Z",
    fill: "#27A536"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5978 15.428V17.9393V28.487H31.2923H33.8201H38.5635V24.8193H31.2923V21.9948H33.8201H38.5635V18.327H31.2923V17.9393V15.428H38.5635V11.762H27.5978V15.428Z",
    fill: "#27A536"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2968 15.428V17.9393V22.3081V24.8193L46.9912 28.487H54.2625V24.8193V22.3081V19.934H50.5697V22.3081V24.8193H46.9912V22.3081V17.9393V15.428H54.2625V11.762H46.9912L43.2968 15.428Z",
    fill: "#27A536"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.639 0H11.7418V3.66777H109.639V28.3702H113.333V3.66777V0H109.639Z",
    fill: "#27A536"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69448 36.3323V11.6299H0V36.3323V40H3.69448H101.591V36.3323H3.69448Z",
    fill: "#27A536"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.91c6ba612026a0f6651c0ddf7f4c01b0.svg";
export { ForwardRef as ReactComponent };